import ScrollReveal from "../../../components/feature/ScrollReveal";
import { whatToWear, whatToBring } from "../../../mocks/firstTimeData";

export default function GuideSection() {
  return (
    <section className="py-16 md:py-24 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <ScrollReveal direction="up">
              <div>
                <p className="section-label mb-3">{whatToWear.label}</p>
                <h2 className="section-title">{whatToWear.title}</h2>

                <div className="mt-6 space-y-5">
                  {whatToWear.content.map((c) => (
                    <div key={c.title} className="p-5 bg-white rounded-lg">
                      <h3 className="text-sm font-semibold text-airdoa-navy mb-2">{c.title}</h3>
                      <ul className="flex flex-col gap-1.5">
                        {c.items.map((item) => (
                          <li key={item} className="flex items-start gap-2 text-sm text-airdoa-gray">
                            <span className="w-4 h-4 flex items-center justify-center text-airdoa-gold shrink-0 mt-0.5">
                              <i className="ri-check-line" />
                            </span>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal direction="up" delay={150}>
              <div>
                <p className="section-label mb-3">{whatToBring.label}</p>
                <h2 className="section-title">{whatToBring.title}</h2>

                <div className="mt-6 space-y-5">
                  {whatToBring.content.map((c) => (
                    <div key={c.title} className="p-5 bg-white rounded-lg">
                      <h3 className="text-sm font-semibold text-airdoa-navy mb-2">{c.title}</h3>
                      <ul className="flex flex-col gap-1.5">
                        {c.items.map((item) => (
                          <li key={item} className="flex items-start gap-2 text-sm text-airdoa-gray">
                            <span className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                              {c.title.includes("できない") ? (
                                <i className="ri-close-line text-red-400" />
                              ) : (
                                <i className="ri-check-line text-airdoa-gold" />
                              )}
                            </span>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}